import * as React from 'react'
import MenuItem from '@mui/material/MenuItem'

import { useHandlers } from './hooks'
import type { ActionProps } from '../typings'

export function DeleteButton(props: ActionProps) {
  const {
    onClose,
    disabled,
    params: { id },
  } = props

  const { onClick } = useHandlers({
    onClose,
    id: +id,
  })

  return (
    <MenuItem
      disabled={disabled}
      onClick={onClick}
      data-test-id={`activitySummary-delete-${id}`}
    >
      Delete
    </MenuItem>
  )
}
